import { Reducer } from "redux";

import { PatientInformationViewResponse } from "../models/Api/PatientInformation";
import { PatientHeaderDefaultValues } from "../constants/Patient";
import { PatientInformationDispatchType } from "../models/DispatchTypes/PatientInformation";
import { PatientInformationActionDispatchTypes } from "../constants/PatientInformation";

export const initialState: PatientInformationViewResponse = {
  loading: false,
  response: PatientHeaderDefaultValues,
  error: null,
};

const UpdatePatientHeaderReducer: Reducer<
  PatientInformationViewResponse,
  PatientInformationDispatchType
> = (state = initialState, action) => {
  switch (action.type) {
    case PatientInformationActionDispatchTypes.PUT_PATIENT_INFORMATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PatientInformationActionDispatchTypes.PUT_PATIENT_INFORMATION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PatientInformationActionDispatchTypes.PUT_PATIENT_INFORMATION_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PatientInformationActionDispatchTypes.PUT_PATIENT_INFORMATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdatePatientHeaderReducer;
